import { apiGet, apiPost } from './default'

/* We return a 200 code with an "error" field for *most* failures */
function handleError(call) {
    return new Promise((resolve, reject) => {
        call.then(response => {
            if (response.error) {
                reject(response.msg);
            } else {
                resolve(response);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

const fetchAllExchanges = function() {
    const url="/webrest/exchanges";
    return apiGet(url);
}

const fetchExchangeDetails = function(payload) {
    const url="/webrest/exchanges/search";
    return handleError(apiPost(url, payload));
}

const getProductsByExchange = function(exchangeSymbol, options) {
    let payload = {
        pageNumber: options.pageNumber,
        pageSize: options.pageSize,
        sortField: options.sortField,
        sortDirection: options.sortDirection,
        exchangeId: exchangeSymbol,
        domain: options.domain,
    }
    if(options.productSymbol){
        payload['productSymbol'] = options.productSymbol;
    }
    const url="/webrest/search/products-by-exchangeId";
    return handleError(apiPost(url, payload));
}

const getProductsByFilters = function(payload) {
    const url="/webrest/search/products-by-filters";
    return handleError(apiPost(url, payload));
}

const getProductsByExchangeAndType = function(exchangeId, productType, options) {
    let payload = {
        pageNumber: options.pageNumber,
        pageSize: options.pageSize,
        sortField: options.sortField,
        sortDirection: options.sortDirection,
        exchangeId: exchangeId,
        productType: productType,
        domain: options.domain,
    }
    if(options.productSymbol){
        payload['productSymbol'] = options.productSymbol;
    }
    const url="/webrest/search/products-by-exchangeId-productType";
    return handleError(apiPost(url, payload));
}

const getOrderTypesByExchange = function(payload) {
    const url="/webrest/orderTypes/" + payload;
    let queryparams = {
        exchangeId: payload
    }
    return handleError(apiGet(url, {
        params: queryparams
    }));
}

const getProducts = function(userInput){
    const payload = {
        symbol: userInput,
        pattern:true,
        referrer:"onebar"
    }
    const url="/portal.proxy/v1/mkt/iserver/secdef/search";
    return handleError(apiPost(url, payload));
}

const getOptionChain = function(payload) {
    const url="/webrest/search/option-chain";
    // const url = "/ibsales.rest.service.local/products/optionChain";
    // const url = "/ibsales.rest.service/products/optionChain";
    return handleError(apiPost(url, payload));
}

const getWarrantOptionChain  = function(payload) {
    const url="/webrest/search/warrant-chain";
    // const url = "/ibsales.rest.service.local/products/warrantChain";
    // const url = "/ibsales.rest.service/products/warrantChain";
    return handleError(apiPost(url, payload));
}

const getContractDetails = function(payload){
    const url="/webrest/search/contract-details";
    // const url = "/ibsales.rest.service.local/products/getContractDetails";
    // const url = "/ibsales.rest.service/products/getContractDetails";
    return handleError(apiPost(url, payload));
}

const getRestrictedProducts = function(){
    const url="/response_handlers/products/i158.json";
    return handleError(apiGet(url));
}

const getSummary = function(conid) {
    const url="/portal.proxy/v1/mkt/iserver/fundamentals/" + conid + "/summary";
    return handleError(apiGet(url));
}

const getSecdefData = function(conid) {
    const url="/portal.proxy/v1/mkt/trsrv/secdef?conids=" + conid;
    return handleError(apiGet(url));
}

const getLoginURL = function() {
    const url="https://www.interactivebrokers.com/response_handlers/ibam/index.php";
    return handleError(apiGet(url));
}
export default {
    fetchAllExchanges,
    fetchExchangeDetails,
    getProductsByExchange,
    getOrderTypesByExchange,
    getProductsByFilters,
    getProductsByExchangeAndType,
    getProducts,
    getOptionChain,
    getWarrantOptionChain,
    getContractDetails,
    getRestrictedProducts,
    getSummary,
    getSecdefData,
    getLoginURL,
    
}